import { useNotify } from '../hooks/useNotify';

export function NotificationBanner() {
  const { current, dismiss } = useNotify();

  const requestLogout = () => {
    dismiss();
    window.dispatchEvent(new Event('pp:logout-requested'));
  };
  if (!current) return null;

  if (current.kind === 'auth-expired') {
    return (
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="auth-expired-title"
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000,
        }}
      >
        <div
          style={{
            background: 'var(--bg-surface)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border)',
            borderRadius: 8,
            padding: '24px 28px',
            minWidth: 320,
            maxWidth: 420,
            boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
          }}
        >
          <h3
            id="auth-expired-title"
            style={{
              margin: '0 0 12px',
              fontSize: 'var(--fs-md)',
              fontWeight: 600,
            }}
          >
            Session expired
          </h3>
          <p style={{ margin: '0 0 20px', fontSize: 'var(--fs-base)', color: 'var(--text-secondary)' }}>
            {current.message}
          </p>
          <button
            type="button"
            onClick={requestLogout}
            style={{
              background: 'var(--brand)',
              color: 'var(--text-on-brand)',
              border: 'none',
              borderRadius: 6,
              padding: '8px 16px',
              fontSize: 'var(--fs-base)',
              cursor: 'pointer',
            }}
          >
            Log in again
          </button>
        </div>
      </div>
    );
  }

  const isError = current.kind === 'error';
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        background: 'var(--bg-surface)',
        color: 'var(--text-primary)',
        border: `1px solid ${isError ? 'var(--color-danger)' : 'var(--border)'}`,
        borderLeft: `4px solid ${isError ? 'var(--color-danger)' : 'var(--brand)'}`,
        borderRadius: 6,
        padding: '10px 16px',
        fontSize: 'var(--fs-base)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
        zIndex: 9999,
        maxWidth: '80vw',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
      }}
    >
      <span>{current.message}</span>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss"
        style={{
          background: 'transparent',
          border: 'none',
          color: 'var(--text-muted)',
          cursor: 'pointer',
          fontSize: 'var(--fs-base)',
          padding: 0,
          lineHeight: 1,
        }}
      >
        ×
      </button>
    </div>
  );
}
